import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Icon } from "../../../../components/Component";

/**
 * Lightweight entry point to the full clinic price / catalog editor (no duplicate editor UI).
 */
export default function ClinicPricesShortcutModal({ isOpen, clinic, onClose, onOpenFullEditor }) {
  const name = (clinic?.name || clinic?.clinicName || "").trim() || "Clinic";

  return (
    <Modal isOpen={Boolean(isOpen)} toggle={onClose} size="lg" zIndex={2000}>
      <ModalHeader toggle={onClose}>Prices — {name}</ModalHeader>
      <ModalBody>
        <p className="text-soft small mb-0">
          Open the full price and catalog editor for this clinic. That screen is the source of truth for catalog, treatment prices, and
          teleconsultation products.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" type="button" onClick={onOpenFullEditor}>
          <Icon name="calc" className="me-1" />
          Open full price editor
        </Button>
      </ModalFooter>
    </Modal>
  );
}
